/**
 * Created by alex.shmaltsuev on 2016-05-08.
 */

import PropTypes from 'prop-types';

import React from 'react';
import Style from './widgetTab.scss';
import C from '../../constants/scoreBoard';
import styled from 'styled-components';
import Cx from 'classnames';

const StyledLoadMore = styled.div`
    background-color: ${props => props.theme.brandContrast};
    border: solid 1px ${props => props.theme.brandColor};
    .loadMoreText {
        margin: 8px;
        text-align: center;
        color: ${props => props.theme.brandColor};    
    }
`;

/**
 *returns a react object of the mobileTab
 */
class TabMobile extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            activePage: 1
        };
    }



    render() {
        if (this.props.isShowAll) {
            let startIndex = 0;
            let endIndex = this.props.listItems.length;
            let numberOfPages = this.props.paginationPageCount||Math.ceil(this.props.listItems.length / C.RECORODS_DISPLAYED_IN_LIST);
            let loadMore;
            let loadLess;
            if (numberOfPages != this.state.activePage) {
                loadMore =
                    <StyledLoadMore onClick={(e) => this.loadNextHandler(e)}
                                    className={Style.showMore}>
                        <p className={Cx(Style.loadMoreText, 'loadMoreText')}>Next Page</p>
                    </StyledLoadMore>;
            }
            if (numberOfPages >1 && this.state.activePage>1) {
                loadLess =
                    <StyledLoadMore onClick={(e) => this.loadPrevHandler(e)}
                                    className={Style.showLess}>
                        <p className={Cx(Style.loadMoreText, 'loadMoreText')}>Previous Page</p>
                    </StyledLoadMore>;
            }
            return (
                <div className={Style.WidgetTabMobileListWrapper}>
                     {loadLess}
                    {this.props.listItems.slice(startIndex, endIndex)}
                    {loadMore}
                </div>
            )

        } else {
            return (
                <div className={Style.WidgetTabMobileListWrapper}>
                    {this.props.listItems}
                </div>
            )
        }

    }

    /**
     * update the pagination active page
     * @param event
     * @param eventKey
     */
     loadNextHandler() {
        let numberOfPages = this.props.paginationPageCount || Math.ceil(this.props.listItems.length / C.RECORODS_DISPLAYED_IN_LIST);
        if (numberOfPages != this.state.activePage) {
            this.setState({
                              activePage: this.state.activePage + 1
                            
                            },()=>{ this.props.customPagination(this.state.activePage,this.props.tabName)});
                            
        }
    }

       /**
     * update the pagination active page
     * @param event
     * @param eventKey
     */
        loadPrevHandler() {
                  this.setState({
                                  activePage: this.state.activePage - 1
                                
                                },()=>{ this.props.customPagination(this.state.activePage,this.props.tabName)});
                                
            
        }
}

TabMobile.propTypes = {
    tabName: PropTypes.string.isRequired,
    setActiveTab: PropTypes.func.isRequired,
    listItems: PropTypes.array.isRequired,
    intlObject: PropTypes.object.isRequired,
    isShowAll: PropTypes.bool.isRequired,
    paginationPageCount:PropTypes.number,
    customPagination:PropTypes.func
};

export default TabMobile;






// WEBPACK FOOTER //
// ./components/Scoreboard/mobileTab.js